import $ from 'jquery';
import _ from 'lodash';
import * as d3 from 'd3';
import usStates5m4326Topo from '@/json/usStates5m4326Topo.json';
import * as topojson from 'topojson-client';
import ky from 'ky';
import CC from '@/cc';
import NRELMT from '@/lib/nrelmt';

(function() {

  var $self = this;
  $self.ProjectsAndPartnerships          = $self.ProjectsAndPartnerships          || {};
  $self.ProjectsAndPartnerships.projects = $self.ProjectsAndPartnerships.projects || {};

  $self.ProjectsAndPartnerships.projects.awards = (function() {
    var pub = {};

    var width = 850,
        height = 500,
        projection,
        path,
        wnResized = false,
        statesFeatures,
        $mapsContainers,
        awardsData,
        mapStoreCollection,

        CONTAINER_DEFAULTS = {
          eventsBound: false,
          transitioning: false,
          mapIsMinified: true
        };

    pub.init = function(params) {
      var projectIds = params.projectIds;

      $mapsContainers = $('.award-box-map');

      mapStoreCollection = CC.utils.getMapStoreCollection();
      awardsData = new NRELMT.FeatureCollection(CC.ProjectsAndPartnerships.projects.awardsData);

      projection = CC.projections.albersUsaVi()
        .scale(1000)
        .translate([width / 2, height / 2]);

      path = d3.geoPath()
        .projection(projection);

      _addSVGsAndSpinners();
      _fetchStateData().then(function(res) {
        statesFeatures = topojson.feature(res, res.objects.usStates5m4326).features;
        _renderMaps(projectIds);
        _addEventListeners();
      });
    };

    function _renderMaps(projectIds) {
      _.each(projectIds, function(projectId) {
        _initMap(projectId);
      });
    }

    function _addEventListeners() {
      $mapsContainers.on('click', _onMapClick);
    }

    function _addScopedEventListeners(id) {
      var ob = mapStoreCollection.get(id);

      if (ob.eventsBound) { return; }
      mapStoreCollection.set(id, 'eventsBound', true)

      // debouncing callback here for sake handling the issues with the two class (party?) system on mapContainer
      ob.$mapContainer.on(CC.browser.transitionEvent, _.debounce(function (e) {
        _onMapTransitionComplete(id, e)
      }, 200));
      $(ob.$mapSiblings[0]).on(CC.browser.transitionEvent, function (e) {
        _onMapSiblingsTransitionComplete(id, e)
      });

      // d3.selectAll($mapContainer[0]).selectAll('.cc-item')
      //   .on('click', function() {
      //     _onCcItemClick(d, $awardContainer);
      //   });
    }

    // function _onCcItemClick(d, $awardContainer)) {
    //   if ($awardContainer.data('mapIsMinified')) { return; }
    //   $awardContainer.data('transitioning', true);
    //   window.location.href = window.location.protocol + '//' + window.location.host + '/national-parks/' + d.properties.short_name;
    //   return;
    // }

    function _onMapTransitionComplete(id, e) {
      if (e.originalEvent.propertyName.indexOf('transform') === -1 || wnResized) { return; }
      var ob = mapStoreCollection.get(id);
      if (ob.$mapContainer.hasClass('transition-to-mini')) {
        _onMapTransitionToMini(id, e);
      } else if (ob.$mapContainer.hasClass('mini')){
        _onMapMini(id, e);
      }
      e.preventDefault();
    }

    function _onMapTransitionToMini (id) {
      var ob = mapStoreCollection.get(id);
      if (ob.mapIsMinified) {
        ob.$mapContainer.removeClass('transition-to-mini');
        mapStoreCollection.set(id, 'transitioning', false)
        mapStoreCollection.set(id, 'mapIsMinified', false)
      } else {
        ob.$mapContainer.removeClass('transition-to-mini').addClass('mini');
      }

    }

    function _onMapMini (id) {
      var ob = mapStoreCollection.get(id);
      if (ob.mapIsMinified) {
        // nothing, just here for consistency
      } else {
        ob.$awardContainer.addClass('mini');
        ob.$mapSiblings.addClass('mini');
      }
    }

    function _onMapSiblingsTransitionComplete(id, e) {
      if (e.originalEvent.propertyName !== 'opacity' || wnResized) { return; }
      var ob = mapStoreCollection.get(id);
      if (ob.mapIsMinified) {
        ob.$mapContainer.removeClass('mini').addClass('transition-to-mini');
      } else {
        mapStoreCollection.set(id, 'transitioning', false)
        mapStoreCollection.set(id, 'mapIsMinified', true)
      }
      e.preventDefault();
    }

    function _onMapClick(e) {
      var id = CC.utils.getIdFromString($(e.currentTarget).attr('id')),
          ob = mapStoreCollection.get(id);

      if (ob.transitioning || wnResized) { return; }
      ob.transitioning = true;
      _addScopedEventListeners(id);

      // see transition callbacks for order
      if (ob.mapIsMinified) {
        // mapsiblings + awardContainer, mapContainer 1st, mapContainer 2nd
        ob.$awardContainer.removeClass('mini');
        ob.$mapSiblings.removeClass('mini');
      } else {
        // mapContainer 1st, mapContainer 2nd, mapsiblings + awardContainer
        ob.$mapContainer.addClass('transition-to-mini');
      }
    }

    function _initMap(projectId) {
      var svg = d3.select('#award-box-map-'+projectId).select('svg'),
          $mapContainer = $('#award-box-map-'+projectId),
          $awardContainer = $mapContainer.parents('.cc-map-content'),
          $mapSiblings = $awardContainer.find('.awards-fades');

      mapStoreCollection.add(projectId, _.merge({}, {
        $mapContainer: $mapContainer,
        $awardContainer: $awardContainer,
        $mapSiblings: $mapSiblings
      }, CONTAINER_DEFAULTS));

      _renderMap(svg, projectId);
    }

    function _renderMap(svg, projectId) {
      _drawStates(svg);
      _fetchInitiativeData(projectId)
        .then(function(res){
          _drawAwards(svg, res.result);
        });
    }

    function _fetchStateData() {
      return new Promise((resolve) => {
        resolve(usStates5m4326Topo);
      });
    }

    function _fetchInitiativeData(projectId) {
      return new Promise((resolve, reject) => {
        ky(`${import.meta.env.VITE_INTERNAL_SHAMWOW_API_URL_ROOT}/v1/projects`, {
          searchParams: {
            api_key: import.meta.env.VITE_INTERNAL_SHAMWOW_CLIENT_SIDE_NLR_API_KEY,
            initiative_id: projectId,
          },
        }).json().then((res) => {
          resolve(res);
        }, reject);
      });
    }

    function _drawStates(svg) {
      NRELMT.Render.states({
        svgEl: svg,
        path: path,
        data: statesFeatures
      });
    }

    function _drawAwards(svg, res) {
      // quick hack to remove extra austin,tx and diamondbar,ca entries
      res = _.reduce(res, function(acc,val) { if (val.id != 111 && val.id != 98) {acc.push(val);} return acc;}, []);
      var points = _getPoints(res),
          statesAffected = _getStatesAffected(res);
      _renderPoints(svg, points);
      _renderLabels(svg, points);
      _updateStates(svg, statesAffected);
      CC.utils.updateSpinner({svg:svg, loading:[], width:width, height:height});
    }

    function _getPoints(res) {
      return {
        type: 'FeatureCollection',
        features: _.reduce(res, function(acc, val) {
          var feature,
              lat,
              lon;
          if (!(lat = val.location.lat) || !(lon = val.location.lon)) { return acc; }
          feature = {
            type: "Point",
            coordinates: [lon, lat],
            properties: {
              org_or_awardee: val.org_or_awardee,
              city: val.city,
              state: val.state,
              id: val.id
            }
          };
          acc.push(feature);
          return acc;
        }, [])
      };
    }

    function _getStatesAffected(res) {
      return _.chain(res)
        .reduce(function(acc, val){
          var states = _.reduce(val.impacted_states || [], function(sAcc, sVal) {
            if (sVal) {sAcc.push(sVal);}
            return sAcc;
          }, []);
          return acc.concat(states);
        }, [])
        .uniq()
        .value();
    }

    function _renderPoints(svg, points) {
      svg.selectAll('.cc-centerpoint')
        .data(points.features)
        .enter().append('circle')
          .attr('cx', function(d) {
            var retVal = path.centroid(d)[0];
            if (isNaN(retVal)) {
              retVal = 1;
            }
            return retVal;
          })
          .attr('cy', function(d) {
            var retVal = path.centroid(d)[1];
            if (isNaN(retVal)) {
              retVal = 1;
            }
            return retVal;
          })
          .attr('r', 3)
          .attr('class', function() {
            return 'centerPoint cc-centerpoint cc-item active';
          });
    }

    function _renderLabels(svg, points) {
      svg.selectAll('.cc-label')
        .data(points.features)
        .enter().append('text')
          .attr('class', function(d) {
            return 'cc-label cc-item active cc-item-' +d.properties.id;
          })
          .attr('transform', function(d) {
            var id = +d.properties.id,
                translate = [path.centroid(d)[0], path.centroid(d)[1]],
                textParams,
                retVal;

            awardsData.createIfNotExists(id.toString());
            textParams = awardsData.get(id.toString()).get('textParams');

            if(_.isEmpty(textParams._dataRaw)) {
              retVal = textParams.getTextTransform(translate, [-15, 15]);
            } else {
              retVal = textParams.getTextTransform(translate);
            }
            return retVal;
          })
          .text(function(d) {
            return d.properties.city+', '+d.properties.state;
          });
    }

    function _updateStates(svg, states) {
      svg.selectAll('.nrelmt-state-boundary')
        .classed('active', function(d) {
          return !!~_.indexOf(states, d.properties.STUSPS);
        });
    }

    function _addSVGsAndSpinners() {
      const svg = d3.selectAll('.award-box-map').append('svg')
        .attr('width', width)
        .attr('height', height);
      CC.utils.updateSpinner({svg:svg, loading:[1], width:width, height:height});
    }

    return pub;
  })();

}).call(CC);

$(".cc-full-map").click(function(){
  $(".close-map").toggleClass("hidden");
});
